import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "flex flex-col card-main" }
const _hoisted_2 = { class: "flex flex-row items-start justify-between" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "flex flex-col w-2/3" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "text-xl font-semibold" }, "Notification settings"),
  /*#__PURE__*/_createElementVNode("span", { class: "text-gray-500 mt-2" }, " Select which email notifications you'd like to receive and their frequency. ")
], -1)
const _hoisted_4 = { class: "flex flex-row items-center justify-end w-1/3" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("span", { class: "mr-2" }, "All notifications", -1)
const _hoisted_6 = {
  key: 0,
  class: "bg-gray-300 h-px w-full my-8"
}
const _hoisted_7 = {
  key: 1,
  class: "flex flex-col"
}
const _hoisted_8 = { class: "flex flex-row items-start justify-between" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("div", { class: "flex flex-col w-2/3" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "font-semibold" }, "Sourcing notifications"),
  /*#__PURE__*/_createElementVNode("span", { class: "text-gray-500 mt-2" }, " Stay on top of the recruitment process by receiving notifications about your jobs and candidates ")
], -1)
const _hoisted_10 = { class: "flex flex-row items-center justify-end w-1/3" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("span", { class: "mr-2" }, "All sourcing notifications", -1)
const _hoisted_12 = { class: "grid grid-rows-5 grid-flow-col mt-6" }
const _hoisted_13 = { class: "capitalize ml-2" }
const _hoisted_14 = {
  key: 2,
  class: "bg-gray-300 h-px w-full my-8"
}
const _hoisted_15 = {
  key: 3,
  class: "flex flex-col"
}
const _hoisted_16 = { class: "flex flex-row items-start justify-between" }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("div", { class: "flex flex-col w-2/3" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "font-semibold" }, "Workforce notifications"),
  /*#__PURE__*/_createElementVNode("span", { class: "text-gray-500 mt-2" }, " Manage your talent efficiently by receiving notifications about their onboarding statuses, payrolls and time-off requests ")
], -1)
const _hoisted_18 = { class: "flex flex-row items-center justify-end w-1/3" }
const _hoisted_19 = /*#__PURE__*/_createElementVNode("span", { class: "mr-2" }, "All workforce notifications", -1)
const _hoisted_20 = { class: "grid grid-rows-3 grid-flow-col mt-6" }
const _hoisted_21 = { class: "capitalize ml-2" }
const _hoisted_22 = /*#__PURE__*/_createElementVNode("div", { class: "bg-gray-300 h-px w-full my-8" }, null, -1)
const _hoisted_23 = /*#__PURE__*/_createTextVNode(" Frequency ")
const _hoisted_24 = { class: "flex flex-row items-start justify-between" }
const _hoisted_25 = /*#__PURE__*/_createElementVNode("div", { class: "flex flex-col w-2/3" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "font-semibold" }, "Email notifications frequency"),
  /*#__PURE__*/_createElementVNode("span", { class: "text-gray-500 mt-2" }, " Let us know how often you’d like to receive the selected notifications through email ")
], -1)
const _hoisted_26 = { class: "flex flex-col items-start w-1/3" }
const _hoisted_27 = /*#__PURE__*/_createElementVNode("span", { class: "text-center" }, "Email frequency", -1)
const _hoisted_28 = ["value"]
const _hoisted_29 = ["value"]
const _hoisted_30 = { class: "flex flex-row justify-end mt-8" }
const _hoisted_31 = ["disabled"]
const _hoisted_32 = { key: 0 }
const _hoisted_33 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SwitchButton = _resolveComponent("SwitchButton")!
  const _component_Checkbox = _resolveComponent("Checkbox")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        _hoisted_5,
        _createVNode(_component_SwitchButton, {
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.changeAll(!_ctx.allNotifications))),
          modelValue: _ctx.allNotifications,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.allNotifications) = $event))
        }, null, 8, ["modelValue"])
      ])
    ]),
    (Object.keys(_ctx.sourcing).length)
      ? (_openBlock(), _createElementBlock("div", _hoisted_6))
      : _createCommentVNode("", true),
    (Object.keys(_ctx.sourcing).length)
      ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
          _createElementVNode("div", _hoisted_8, [
            _hoisted_9,
            _createElementVNode("div", _hoisted_10, [
              _hoisted_11,
              _createVNode(_component_SwitchButton, {
                onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.changeSourcing(!_ctx.allSourcing))),
                modelValue: _ctx.allSourcing,
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.allSourcing) = $event))
              }, null, 8, ["modelValue"])
            ])
          ]),
          _createElementVNode("div", _hoisted_12, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.sourcing, (value, name) => {
              return (_openBlock(), _createElementBlock("div", {
                key: name,
                class: "flex flex-row items-center mt-2"
              }, [
                _createVNode(_component_Checkbox, {
                  selected: _ctx.sourcing[name],
                  "onUpdate:selected": ($event: any) => ((_ctx.sourcing[name]) = $event)
                }, null, 8, ["selected", "onUpdate:selected"]),
                _createElementVNode("span", _hoisted_13, _toDisplayString(String(name).replaceAll("_", " ")), 1)
              ]))
            }), 128))
          ])
        ]))
      : _createCommentVNode("", true),
    (Object.keys(_ctx.workforce).length)
      ? (_openBlock(), _createElementBlock("div", _hoisted_14))
      : _createCommentVNode("", true),
    (Object.keys(_ctx.workforce).length)
      ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
          _createElementVNode("div", _hoisted_16, [
            _hoisted_17,
            _createElementVNode("div", _hoisted_18, [
              _hoisted_19,
              _createVNode(_component_SwitchButton, {
                onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.changeWorkforce(!_ctx.allWorkforce))),
                modelValue: _ctx.allWorkforce,
                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.allWorkforce) = $event))
              }, null, 8, ["modelValue"])
            ])
          ]),
          _createElementVNode("div", _hoisted_20, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.workforce, (value, name) => {
              return (_openBlock(), _createElementBlock("div", {
                key: name,
                class: "flex flex-row items-center mt-2"
              }, [
                _createVNode(_component_Checkbox, {
                  selected: _ctx.workforce[name],
                  "onUpdate:selected": ($event: any) => ((_ctx.workforce[name]) = $event)
                }, null, 8, ["selected", "onUpdate:selected"]),
                _createElementVNode("span", _hoisted_21, _toDisplayString(String(name).replaceAll("_", " ")), 1)
              ]))
            }), 128))
          ])
        ]))
      : _createCommentVNode("", true),
    _hoisted_22,
    _hoisted_23,
    _createElementVNode("div", _hoisted_24, [
      _hoisted_25,
      _createElementVNode("div", _hoisted_26, [
        _hoisted_27,
        _createElementVNode("select", {
          value: _ctx.frequency,
          onChange: _cache[6] || (_cache[6] = ($event: any) => (_ctx.onChange($event))),
          class: "px-2 py-4 pl-4 pr-10 block w-full px-0 mt-0 bg-transparent bg-gray-200 border-2 rounded-lg border-solid focus:outline-none focus:ring-0 focus:border-gray-200 border-gray-200"
        }, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.frequencies, (freq, i) => {
            return (_openBlock(), _createElementBlock("option", {
              key: i,
              value: freq
            }, [
              _createElementVNode("span", null, _toDisplayString(freq.charAt(0).toUpperCase() + freq.slice(1)), 1)
            ], 8, _hoisted_29))
          }), 128))
        ], 40, _hoisted_28)
      ])
    ]),
    _createElementVNode("div", _hoisted_30, [
      _createElementVNode("button", {
        onClick: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.saveNotificationSettings && _ctx.saveNotificationSettings(...args))),
        class: _normalizeClass(["space-x-3 btn-filled-sm flex flex-row items-center disabled:opacity-50 justify-between truncate text-base bg-primary rounded-full transition duration-150 ease-in disabled:cursor-not-allowed", {
          'btn-filled-sm-loading': _ctx.loading,
        }]),
        disabled: _ctx.loading
      }, [
        (!_ctx.loading)
          ? (_openBlock(), _createElementBlock("span", _hoisted_32, "Save changes"))
          : (_openBlock(), _createElementBlock("span", _hoisted_33, "Loading..."))
      ], 10, _hoisted_31)
    ])
  ]))
}